export default __webpack_public_path__ + "static/media/FCU.87df6b86.png";